export default __webpack_public_path__ + "static/21-76d0cb663435e93acb998169740e3e6e.jpg";